module.exports = __webpack_public_path__ + "img/punga-accommodation.778adf8b.jpg";